import { createWritableGenericContext } from '@luna/context';

import { ImageUploadModal } from './ImageUploadService';

type ContextValues = {
    currentModal: ImageUploadModal;
    imageUrl: string;
};
const { createContextProvider, useContext } =
    createWritableGenericContext<ContextValues>('image-upload-context');

export const ImageUploadProvider = createContextProvider({
    currentModal: ImageUploadModal.None,
    imageUrl: '',
}).Provider;

type HookReturn = {
    currentModal: ImageUploadModal;
    imageUrl: string;
    setImageUrl: (image: string) => void;
    openUploadSuccessModal: () => void;
    openRemoveSuccessModal: () => void;
    openRemovalModal: () => void;
    openErrorModal: () => void;
    openResizeModal: () => void;
    openLoadingModal: () => void;
    closeModal: () => void;
};

export const useImageUploadContext = (): HookReturn => {
    const { value: contextValues, setValue } = useContext();

    const handleModalChange = (modal: ImageUploadModal): void =>
        setValue(({ imageUrl }) => ({ currentModal: modal, imageUrl }));

    return {
        currentModal: contextValues.currentModal,
        imageUrl: contextValues.imageUrl,
        setImageUrl: (image: string) =>
            setValue(({ currentModal }) => ({ currentModal, imageUrl: image })),
        closeModal: () => setValue({ currentModal: ImageUploadModal.None, imageUrl: '' }),
        openErrorModal: () => handleModalChange(ImageUploadModal.ErrorModal),
        openRemovalModal: () => handleModalChange(ImageUploadModal.RemovalModal),
        openLoadingModal: () => handleModalChange(ImageUploadModal.LoadingModal),
        openResizeModal: () => handleModalChange(ImageUploadModal.ResizeModal),
        openRemoveSuccessModal: () => handleModalChange(ImageUploadModal.RemoveSuccessModal),
        openUploadSuccessModal: () => handleModalChange(ImageUploadModal.UploadSuccessModal),
    };
};
